import axios from 'axios';
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
  CloseOutlined,
  CheckCircleOutlined,
  DragOutlined
} from '@ant-design/icons';

export default {
  getLecturer: async function (setFuncMap) {
    try {
      const res = await this.getLecturerAction()
      setFuncMap.setLecturer(res.data)
      setFuncMap.setIsPageLoading(false)
    } catch (error) {
    }
  },
  getLecturerAction: () => {
    return axios({
      method: 'GET',
      url: `/site/lecturer`
    })
  }
};
